import React from 'react';
import Title from '../shared/Title';
import http from '../../utils/http';
import { _path } from '../../data/headerNavigation';
import TableNav from '../slide/TableNav';
import Grafics from './Grafics';

export default function HomePage(props) {

    http('about/info').asGet().then(resp => resp);

    return (
        <div className="container mt-10" style={{ display: 'flex', justifyContent: 'space-between'}}>
            <Title title="Inicio" />
            <div style={{ width: '200px'}}>
                <div style={{ width: '200px', marginTop:'50px', marginLeft: '50px'}}>
                    Acceso rápido
                    <table className="table  table-hover lf-sm-table" id="pdsTable">
                    <TableNav fs='fs22' />
                    </table>
                </div>
            </div>
            <div  style={{ width: '75%'}}>
                <Grafics />
            </div>
        </div>
    )
}

